<div class="main-content mt-16">
  @if (iconSet()) {
  <div class="px-4 pb-3 pt-4">
    @if (hasErrors) {
    <div class="ml-3">
      @if (showNoAccessError) {
      <div>
        <app-no-access-error></app-no-access-error>
      </div>
      } @else {
      <div class="mt-3 dashboard-error">
        <div>
          <h3 style="text-align: center;">{{errorMessage}}</h3>
        </div>
      </div>
      }
    </div>
    } @else {
    <div class="container">
      <div class="grid md:grid-cols-12 md:flex min-h-3">
        <div class="grid-cols-12 md:contents">
          @for (breadcrumb of breadcrumbs; track breadcrumb) {
          <div class="custom-breadcrumb">
            <a class="custom-breadcrumb__text" routerLinkActive="active" [routerLink]="breadcrumb.route"
              [queryParams]="breadcrumb.queryParams" [title]="breadcrumb.name" (click)="breadcrumbClick(breadcrumb)"
              data-cy="breadcrumbText">
              {{breadcrumb.name}}</a>
            <mat-icon class="custom-breadcrumb__icon">chevron_right</mat-icon>
          </div>
          }
          <app-auto-adjusting-dropdown [selected]="seriesNameForBreadcrumb()"
            [dataForBreadcrumbs]="portfolioDataForBreadcrumb" (goToSelected)="goToSelectedSeries($any($event))"
            [selectedValue]="seriesId()" [valueProperty]="'displayId'" [nameProperty]="'displayName'"
            [groupProperty]="'subEntities'" [showOneOptGroup]="true" [type]="'Series'"
            data-cy="seriesDropdown"></app-auto-adjusting-dropdown>
        </div>
      </div>

      <div class="portfolio-summary flex flex-wrap">
        <div class="portfolio-title min-h-10 pb-0 text-md lg:text-lg" data-cy="portfolioLabel">
          {{portfolioSummary()?.name}} </div>
        <div class="flex ml-auto mt-1">
          <div>
            <img src="{{iconSet()['icon.calendar']}}" class="mt-3.5 mr-1.5" alt="Calendar" />
          </div>
          <gcm-date-picker [dateOptionList]="asOfDropdownData" [date]="selectedAsOfDate()"
            (dateChange)="updateAsOfDate($any($event))" [selectPanelClass]="'as-of-date-panel'"
            data-cy="asOfDateDropdown" class="as-of-date mr-3"
            [ngClass]="{'error-text' : isPortfolioSeriesDataUnavailable && selectedAsOfDate()}"></gcm-date-picker>
        </div>
      </div>

      @if (isPortfolioSeriesDataUnavailable) {
      <app-data-unavailable-card
        entityLabel="Series"
        [selectedDate]="selectedAsOfDate()"
        [backRoute]="breadcrumbs[0]?.route"
        [backQueryParams]="breadcrumbs[0]?.queryParams"
        (backClick)="breadcrumbClick(breadcrumbs[0])"
        data-cy="errorCard">
      </app-data-unavailable-card>
      }
      @else if(assetClasses()){
      <!-- switch on asset classes to determine which dashboard component to render (dashboardData.summary.assetClasses)-->
      @switch (dashboardType()) {
        @case (AssetClass.RealEstate) {
          <app-series-dashboard-real-estate [iconSet]="iconSet()" [dashboardData]="dashboardData()"
            [selectedAsOfDate]="selectedAsOfDate()" [seriesNameForBreadcrumb]="seriesNameForBreadcrumb()"
            [investorId]="investorId()" [seriesId]="seriesId()"
            [reportingPeriod]="reportingPeriod()"></app-series-dashboard-real-estate>
        }
        @case (AssetClass.Infrastructure) {
          <app-series-dashboard-infrastructure [iconSet]="iconSet()" [dashboardData]="dashboardData()"
            [selectedAsOfDate]="selectedAsOfDate()" [seriesNameForBreadcrumb]="seriesNameForBreadcrumb()"
            [investorId]="investorId()" [seriesId]="seriesId()"
            [reportingPeriod]="reportingPeriod()"></app-series-dashboard-infrastructure>
        }
        @default {
          <app-series-dashboard-private-equity [iconSet]="iconSet()" [dashboardData]="dashboardData()"
            [selectedAsOfDate]="selectedAsOfDate()" [seriesNameForBreadcrumb]="seriesNameForBreadcrumb()"
            [investorId]="investorId()" [seriesId]="seriesId()"
            [reportingPeriod]="reportingPeriod()"></app-series-dashboard-private-equity>
        }
      }
      }
    </div>
    }
  </div>
  }
</div>